import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-project-invoice',
  templateUrl: './app-project-invoice.component.html',
  styleUrls: ['./app-project-invoice.component.scss']
})
export class AppProjectInvoiceComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }

}
